<div class="popup popup-basic" class="bfx-order-recap" fxLayout="column">
  <div class="order-recap-table">
    <div *ngFor="let orderRecap of recapResults" class="order-recap-row">
      <span class="order-recap-value">{{orderRecap}}</span>
    </div>
  </div>
  <div class="bfx-callout-info-sm" *ngIf="recapInfo">
    <i class="icon-info"></i>
    <span>{{stringToDisplay}}</span>
  </div>
  <div class="bfx-callout-negative-sm" *ngIf="recapError">
    <i class="icon-error"></i>
    <span>{{stringToDisplay}}</span>
  </div>
  <div class="popup-footer">
    <button class="bfx-button-secondary-moderate diAction" (click)="close()" type="submit">
      Close
    </button>
    <button
      class="bfx-button-primary diAction"
      (click)="actionExport_copyToClipboard()"
      type="button"
      [disabled]="recapInfo || recapError"
    >
      Copy to Clipboard
    </button>
  </div>
</div>
